import * as THREE from "three";
import {TrackProp} from "./trackProp.js";

/**
 * An orb track prop, which has no model but emits light
 */
export class TrackPropOrb extends TrackProp {
    static SHADER_VERTEX = `
        uniform float radius;
        
        varying vec2 vUv;

        void main() {
            vUv = uv;

            vec4 finalPosition = modelViewMatrix * vec4(0.0, 0.0, 0.0, 1.0);
            
            finalPosition.xy += position.xy * radius;

            gl_Position = projectionMatrix * finalPosition;
        }

        `;
    static SHADER_FRAGMENT = `
        #define GLOW_POWER .8
        #define CORE_RADIUS_POWER 1.7
        #define TRANSPARENCY .5
        
        uniform vec3 color;
    
        varying vec2 vUv;
        
        void main() {
            vec2 delta = vUv - .5;
            float radius = length(delta);
            float spike = 1.;
            float alpha = 1. - radius - radius + pow(1. - radius - radius, CORE_RADIUS_POWER);
        
            gl_FragColor = vec4(mix(vec3(1.), color, pow(radius + radius, GLOW_POWER)), alpha * alpha * TRANSPARENCY);
        }
        `;

    /**
     * Construct an orb prop
     * @param {number} color The orb color
     * @param {number} radius The orb radius
     * @param {TrackPropInstance[]} instances The instances for this prop
     */
    constructor(color, radius, instances) {
        super(null, instances);

        this.color = color;
        this.radius = radius;
    }

    /**
     * Load this prop
     * @returns {Promise} A promise which resolves when the prop was loaded
     */
    load() {
        return new Promise(resolve => {
            const material = new THREE.ShaderMaterial({
                uniforms: {
                    radius: {value: this.radius},
                    color: new THREE.Uniform(new THREE.Color(this.color))
                },
                vertexShader: TrackPropOrb.SHADER_VERTEX,
                fragmentShader: TrackPropOrb.SHADER_FRAGMENT,
                transparent: true,
                blending: THREE.AdditiveBlending
            });

            const sprite = new THREE.Sprite(material);

            this.scene = new THREE.Scene();
            this.scene.add(sprite);

            resolve();
        });
    }
}